module.exports = "/../../dist/frontend/images/R-DAM_1385359.webp?69b05b3867b1d77630d32f4d8fff77d0";